var borders = {
  base: "1px solid"
};
export { borders as default };